module.exports = __webpack_public_path__ + "img/emoji-trophy-240x240.b055451b.png";